
import { AdfsAuthService } from '@anb/ng-auth';
import { AnbLoadingService } from '@anb/ng-ui';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CoreService } from 'app/modules/_core/services/core.service';
import { Environment } from 'environments/environment';
import { filter } from 'rxjs/operators';

/**
 * Bootstrap component
 *
 * @export
 * @class AppComponent
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  anbEnvironment = Environment.anbEnvironment;
  loginUrl = Environment.loginUrl;
  logoutUrl = Environment.logoutUrl;
  get hasAuthenticatedSession() {
    return this._authService.token && !this._authService.isTokenExpired
  }
  browserSupported = false;

  constructor(
    public loadingService: AnbLoadingService,
    private _router: Router,
    private _authService: AdfsAuthService,
    private _coreService: CoreService,
  ) {
    _router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      window.scroll(0, 0);
    });

    this.browserSupported = this._coreService.browserSupported();
  }

  logout() {
    this._authService.token = null;
    window.location.href = Environment.logoutUrl;
  }
}
